module.exports = __webpack_public_path__ + "img/faro_background.5a0a375d.svg";